import React, { createContext, useEffect, useMemo, useState } from "react";
import { socket } from "../Components/Options";
import { jwtDecode } from "jwt-decode";

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
    const [apiUrl] = useState('https://quickinventoryapi.royalbakery.co.in');
    const [baseurl] = useState('https://quickinventory.royalbakery.co.in/');
    const [token, setToken] = useState(localStorage.getItem("authToken") || null);
    const [user_id, setUserId] = useState(localStorage.getItem("user_id") || null);
    const [user_role, setuser_role] = useState(localStorage.getItem("user_role") || null);
    const [user_name, setuser_name] = useState(localStorage.getItem("user_name") || null);
    const [store_id, setstore_id] = useState(localStorage.getItem("store_id") || null);
    const [selected_store_id, set_selected_store_id] = useState(localStorage.getItem("selected_store_id") || null);
    const [routes, set_routes] = useState(JSON.parse(localStorage.getItem('routes')) ?? []);
    const [device_id, set_device_id] = useState(localStorage.getItem("device_id") || null);

    const apiHeadersJson = useMemo(() => ({
        "Content-Type": "application/json",
        token,
        'user-id': user_id,
        user_id,
        'user-role': user_role,
        user_role,
        store_id,
        "store-id": store_id,
        selected_store_id,
        'selected-store-id': selected_store_id
    }), [token, user_id, user_role, store_id, selected_store_id]);

    const apiHeadersFile = useMemo(() => ({
        "Content-Type": "multipart/form-data",
        token,
        'user-id': user_id,
        user_id,
        'user-role': user_role,
        user_role,
        store_id,
        "store-id": store_id,
        selected_store_id,
        'selected-store-id': selected_store_id
    }), [token, user_id, user_role, store_id, selected_store_id]);

    const isTokenExpired = (token) => {
        try {
            const { exp } = jwtDecode(token);
            if (!exp) return true;
            const currentTime = Date.now() / 1000;
            return exp < currentTime;
        } catch (error) {
            console.error("Failed to decode token:", error);
            return true;
        }
    };


    const Login = (data) => {
        localStorage.setItem("authToken", data.token);
        localStorage.setItem("user_name", data.user_name);
        localStorage.setItem("user_id", data.user_id);
        localStorage.setItem("user_role", data.user_role);
        localStorage.setItem("store_id", data.store_id);
        localStorage.setItem("selected_store_id", data.store_id);
        setToken(data.token);
        setUserId(data.user_id);
        setuser_role(data.user_role);
        setuser_name(data.user_name);
        setstore_id(data.store_id);
        set_selected_store_id(data.store_id);
    };

    const Logout = () => {
        localStorage.clear();
        window.location.href = '#/login';
    };

    const setDateRange = (fromDate, toDate) => {
        localStorage.setItem("from_date", fromDate);
        localStorage.setItem("to_date", toDate);
    };

    useEffect(() => {
        if (selected_store_id) {
            localStorage.setItem('selected_store_id', selected_store_id);
        }
    }, [selected_store_id]);

    useEffect(() => {
        const activeStoreId = selected_store_id || store_id;
        if (!activeStoreId || !user_role) return;

        const joinStore = () => {
            socket.emit("join_store", {
                store_id: activeStoreId,
                role: user_role,
                user_id: user_id,
                user_name: user_name || "User",
                device_type: user_role || "qr",
            });
        };

        !isTokenExpired(token) && joinStore();

        socket.on("connect", () => {
            console.log("Socket reconnected:", socket.id);
            !isTokenExpired(token) && joinStore();
        });

        return () => {
            socket.off("connect");
        };

    }, [selected_store_id, store_id, user_role]);


    useEffect(() => {
        if (device_id) {
            localStorage.setItem("device_id", device_id);
        } else {
            localStorage.removeItem("device_id");
        }
    }, [device_id]);

    const vals = {
        apiUrl,
        user_id,
        Login,
        Logout,
        token,
        setDateRange,
        apiHeadersJson,
        user_role,
        baseurl,
        store_id: selected_store_id || store_id,
        set_selected_store_id,
        apiHeadersFile,
        set_routes,
        auth_routes: routes,
        set_device_id,
        device_id
    };


    return (
        <ConfigContext.Provider value={vals}>
            {children}
        </ConfigContext.Provider>
    );
};
